import { Col, FlexView, Row } from '@cuemath/comps';
import { Button, Separator, Text } from '@cuemath/web-comps';
import React from 'react';
import useLogic from './logic';
import SelectInput from 'comps/inputs/dropdown';
import styled from 'styled-components';
import { LICENSE_INPUT_TYPES } from 'constants/license';

const CustomSelectInput = styled(SelectInput)`
  width: 100%;
`;
const EditTeacherLicenseModal = ({ id, program, geos, gradeGroups }) => {
  const {
    handleSave,
    handleChange,
    handleClose,
    regions,
    grades,
    gradeOptions,
    regionOptions,
  } = useLogic({
    geos,
    gradeGroups,
  });

  return (
    <FlexView gutter={16} gap={16}>
      <Text variant="h5">{program}</Text>
      <Separator height={24} />
      <Row alignItems="center">
        <Col gutter={0}>
          <Text variant="body2">Grades</Text>
        </Col>
        <Col gutter={8} />
        <Col gutter={0} auto>
          <CustomSelectInput
            name={LICENSE_INPUT_TYPES.GRADES}
            onChange={() => handleChange('grades')}
            options={gradeOptions}
            isMulti={true}
            isDisabled={false}
            value={grades}
            maxMenuHeight={200}
          />
        </Col>
      </Row>
      <Separator height={16} />
      <Row alignItems="center">
        <Col gutter={0}>
          <Text variant="body2">Regions</Text>
        </Col>
        <Col gutter={8} />
        <Col auto gutter={0}>
          <CustomSelectInput
            name={LICENSE_INPUT_TYPES.REGIONS}
            onChange={() => handleChange('regions')}
            options={regionOptions}
            isMulti={true}
            isSearchable
            value={regions}
            maxMenuHeight={200}
          />
        </Col>
      </Row>
      <Separator height={32} />
      <Row justifyContent="center">
        <Col gutter={8}>
          <Button
            onClick={handleClose}
            width="175px"
            size="small"
            variant="secondary"
            label="Close"
          />
        </Col>
        <Col gutter={8}>
          <Button onClick={handleSave} width="175px" size="small" label="Save" />
        </Col>
      </Row>
    </FlexView>
  );
};

export default EditTeacherLicenseModal;
